import React from 'react'
import type { FC } from 'react'
import { useParams } from 'react-router-dom'

import { VTEXIFrame } from '../../core/components/VTEXIFrame'

export const IFrameScreen: FC = () => {
  const params = useParams<string[]>()

  const [iframePath] = params

  return <VTEXIFrame path={iframePath} />
}
